import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from 'App';
import { Button } from 'AppStyles';
import { OfferContainer, Ribbon, RibbonText, PackageId, Header, Fotter, Icon, Price } from './Styles';
import { Goods } from 'components';
import { helper } from 'utils';

const StorePackTimer = ({ state }) => {
  const [timer, setTimer] = useState('');

  useEffect(() => {
    if (!(state && 'exs' in state)) return;

    const timerId = setInterval(() => {
      const exs = state.exs;

      const now = Date.now() / 1000;

      if (now > exs) {
        setTimer('');
        return;
      }

      const diff = exs - now;

      const toTimeFormat = value => (value < 10 ? '0' + value : value);

      const h = parseInt(diff / 60 / 60, 10);
      const m = parseInt((diff / 60) % 60, 10);
      const s = parseInt(diff % 60, 10);

      setTimer(`${toTimeFormat(h)}:${toTimeFormat(m)}:${toTimeFormat(s)}`);
    }, 1000);

    return () => {
      clearInterval(timerId);
    };
  }, [state]);

  return <>{timer}</>;
};

const Offer = ({ offer, background, offersLength }) => {
  const { selectStorePackage } = useApp();
  const { izid, gLt, cot, cCot, pMe, vLt, assetKey } = offer;

  const headerAssets = require.context('assets/offer/icons', false);
  const headerAssetsMap = helper.assetsMapper(headerAssets);

  const navigate = useNavigate();
  const defaultAsset = 'regular-2';

  const handleButtonClicked = () => {
    selectStorePackage(offer);
    navigate('/checkout');
  };

  return (
    <OfferContainer $offersLength={offersLength}>
      {!!pMe && (
        <Ribbon>
          <RibbonText>{pMe}%</RibbonText>
        </Ribbon>
      )}
      {helper.isDebugMode && <PackageId>{izid}</PackageId>}
      <Header $background={background}>
        <Icon src={headerAssetsMap[assetKey] || headerAssetsMap[defaultAsset]} />
      </Header>
      <Fotter>
        <Goods goods={gLt} withStyle />
        {!!cCot && <Price>$ {cCot}</Price>}
        <Button onClick={handleButtonClicked}>${cot}</Button>
        {!!vLt && <StorePackTimer vLt={vLt} />}
      </Fotter>
    </OfferContainer>
  );
};

export default Offer;
